module.exports = __webpack_public_path__ + "img/p2@2x.68046641.jpg";